<template>
    <transition name="fade">
        <div class="undo-wrapper" v-if="message">
            <div class="undo-inner">
                <span>
                    {{ message }}
                </span>
                <button class="btn" @click="undo">
                    Undo
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapState } from 'vuex';
    import Undo         from "../../../Lib/Objects/Undo";

    export default {
        name: "Undo",

        computed: {
            ...mapState('Undo', {
                message: state => state.message,
            }),
        },

        methods: {
            undo() {
                Undo.cancel();
            }
        }


    }
</script>

<style lang="scss" scoped>
    $white: #fff;
    $purple: #684999;
    $body-accent-dark: #1f2020;

    .undo-wrapper {
        position: fixed;
        right: 0;
        bottom: 0;
        padding: 1rem;

        .undo-inner {
            display: flex;
            align-items: center;
            font-size: 0.75rem;
            background-color: $purple;
            padding: 0 0 0 1rem;
            color: $white;
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0 0 16px 0 $body-accent-dark;

            span {
                padding-right: 1rem;
            }

            button {
                color: $white;
                border-radius: 0;
                border-top: none;
                border-bottom: none;
                border-left: 1px solid darken($purple, 8%);
                min-width: 5rem;
                padding: 0 1rem;
            }
        }

        @media screen and (max-width: 767px) {
            bottom: 5rem;

            .undo-inner {
                font-size: 1rem;

                button {
                    line-height: 3rem;
                }
            }
        }
    }
</style>